import tooltip from 'common/utils/tooltip';

class ManagerYearInlineController {

  constructor($rootScope, $scope, $timeout, EventEmitter) {
    'ngInject';
    this.rootScope = $rootScope;
    this.scope = $scope;
    this.timeout = $timeout;
    this.loaded = false;
    this.today = new Date();
    this.tooltip = tooltip;
    this.isHiddenInfo = false;
    this.date = this.today;
    this.EventEmitter = EventEmitter;
  }

  hideInfo({ hide }) {
    this.isHiddenInfo = hide;
  }

  $onInit() {
    this.onChangeDate(this.EventEmitter({ currentDate: this.date }));
  }

  nextPage() {
    let currentMonth = this.date.getMonth();
    this.date = new Date(this.date.getFullYear(), currentMonth + 1, 1);
    this.onChangeDate(this.EventEmitter({ currentDate: this.date }));
  }

  prevPage() {
    let currentMonth = this.date.getMonth();
    this.date = new Date(this.date.getFullYear(), currentMonth - 1, 1);
    this.onChangeDate(this.EventEmitter({ currentDate: this.date }));
  }

  yearChanges($event) {
    this.onYearPaginationChanges(this.EventEmitter($event));
  }

}

export default ManagerYearInlineController;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/features/teamCalendar/managerYearInline/managerYearInline.controller.js